module.exports = __webpack_public_path__ + "img/default-shop-logo.0345de73.png";